import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'

import { utils, useForm } from 'passiv-libs'
import { LPA } from 'passiv-api'

import Forgot from './forgot'

const ForgotContainer = () => {
  const history = useHistory()
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)
  const [recaptchaToken, setRecaptchaToken] = useState('')
  const [siteKey, setSiteKey] = useState('')

  const { register, watch } = useForm({ mode: 'onChange' })

  const { errors } = utils.user.userValidateNonEmpty({
    user: watch('username')
  })

  useEffect(() => {
    init()
  }, [])

  const init = async () => {
    // Localhost is not in the list of supported domains for this site key.
    // setSiteKey('6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI') // google test site key
    const val = await LPA.getRecaptchaChallenge()
    setSiteKey(val)
  }

  const reset = async () => {
    try {
      // NB while non-passiv siteKey is entered, LPA.reset will 403
      await LPA.reset({ username: watch('username'), siteKey, recaptchaToken }) // trigger email
      setDone(true)
    } catch (error) {
      if (error) setError(error.type)
    }
  }

  return (
    <Forgot
      error={error}
      register={register}
      done={done}
      siteKey={siteKey}
      disabled={!recaptchaToken || errors.length > 0}
      onRecaptcha={setRecaptchaToken}
      onBack={() => history.push('/login')}
      onReset={reset}
      onClickDone={() => history.push('login')}
      onClearError={() => setError('')}
    />
  )
}

export default ForgotContainer
